import { formatNumber } from '@gonfalon/format/formatNumber';

export const MONTHS_IN_YEAR = 12;
export const CENTS_PER_DOLLAR = 100;

/**
 * Formats a number with different rules based on its magnitude.
 * For numbers with absolute value > 9999, uses compact notation with abbreviations (K, M, B).
 * For smaller numbers, uses standard formatting with up to 2 decimal places.
 * This can be used to format entitlements. Please use formatCurrency for pricing.
 *
 * @param value - The number to format
 * @returns A formatted string representation of the number
 *
 * @example
 * // Large numbers use compact notation
 * formatLargeNumber(10000)     // returns "10K"
 * formatLargeNumber(1500000)   // returns "1.5M"
 * formatLargeNumber(-25000)    // returns "-25K"
 *
 * // Smaller numbers use standard formatting
 * formatLargeNumber(9999)      // returns "9,999"
 * formatLargeNumber(123.456)   // returns "123.46"
 * formatLargeNumber(1000)      // returns "1,000"
 * formatLargeNumber(-1234)     // returns "-1,234"
 */
export function formatLargeNumber(value: number) {
  if (value > 9999 || value < -9999) {
    return formatNumber(value, {
      compactDisplay: 'short',
      notation: 'compact',
      maximumFractionDigits: 1,
    });
  }
  return formatNumber(value, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
}
